import h from 'virtual-dom/h';
import { sendRequest } from '../../../lib-alme-request/src/lib-alme-request';
import { allowNav, isDNNLocation } from '../../../../util/dnn';
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState} from "../../../../wireup/AlmeState";
import {VNode} from "virtual-dom";
import {DisplayLink} from "@alme/types/response/DisplayLink";
import {Dictionary, Mutator} from "../../../../types/rendering";
import {Input} from "../../../../types/input";
import {setMinimize} from "../../../window-minimize/src/actions/actions";
import { Message } from '../../../../types/response';

type StepOutIcon = { renderIcon: (url: string) => VNode | undefined };

export default class UrlLinkBuilder
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _stepOutIcon: StepOutIcon | null;
    _linkMutators: Mutator[] = [];


    //#region Public Interface

    constructor(settings: DefaultSettings, stepOutIcon: StepOutIcon | null, linkMutators: Mutator[] = [])
    {
        this._settings = settings;
        this._stepOutIcon = stepOutIcon;
        this._linkMutators = linkMutators;
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;
    }

    buildUrlLink(link: DisplayLink): VNode[]
    {
        const shouldDisable = this._store?.getState().Window.DisplayLinksUrl.shouldDisable;

        const isDownloadLink = link.Metadata.Download ? true : false;

        let parameters: Dictionary = shouldDisable
        ? {
            tabindex: -1,
            href: '/',
            onclick: (): boolean => false,

        }
        : isDownloadLink ? 
            {
                href: link.Metadata.UrlAddress,
                download: link.Metadata.Download,
                onclick: (): boolean => {
                    this.urlOnClickReporting(link);
                    return true;
                },
            }
            : {
                tabindex: 0,
                href: isDNNLocation(window.location, this._settings) ? '' : link.Metadata.UrlAddress,
                target: this.isPopup(link) ? "_blank" : "_self",
                onclick: (): boolean => {
                    this.urlOnClick(link);
                    return false;
                },
            };

        parameters = this._linkMutators.reduce((props, mutate) => mutate(props), parameters)
        
        const stepOutNode = this._stepOutIcon?.renderIcon(link.Metadata.UrlAddress as string);

        let children = [h('a', parameters, stepOutNode ? [link.DisplayText, stepOutNode] :link.DisplayText)];

        const properties = {
            className: shouldDisable ? this._settings.classNames.displayLinkDisabled : this._settings.classNames.urlDisplayLink,
        };

        return [h('div', properties, children)];
    }

    //#endregion



    //#region OnClick Methods

    urlOnClick(link: DisplayLink): void
    {
        if (link.Metadata.NavigationType !== this._settings.navConstants.linkTypes.none)
        {
            this.minimizeAgentInMobileView();
        }

        const navPromise = this.urlOnClickReporting(link);

        if (this.isPopup(link))
        {
            //NOTE: Chrome blocks popup if window.open is in 'promise.then'
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            navPromise.then(() => { });

            window.open(link.Metadata.UrlAddress as string, '_blank')?.focus();
        }
        else if (allowNav(window.location, this._settings))
        {
            navPromise.then(() =>
            {
                this.setWindowLocationHref(link.Metadata.UrlAddress as string);
            });
        }
    }

    urlOnClickReporting(link: DisplayLink): Promise<Message>
    {
        const input: Input =
        {
            eventName: 'UrlClicked',
            eventValue: link.Metadata.UrlAddress as string,
            messageType: this._settings.messageConstants.reportingEventRequest,
        };

        return sendRequest(input);
    }

    //#endregion



    //#region Helper Methods

    setWindowLocationHref(url: string): void
    {
        window.location.href = url;
    }

    isPopup(link: DisplayLink): boolean
    {
        return link.Metadata.NavigationType === this._settings.navConstants.linkTypes.popup;
    }

    minimizeAgentInMobileView(): void
    {
        const windowWidth = window.innerWidth ?? document.documentElement.clientWidth ?? document.body.clientWidth;

        if (windowWidth <= this._settings?.Mobile?.breakpoint ?? -1)
        {
            this._store?.dispatch(setMinimize(true, this._settings.stateLocations.Window.IsMinimized));
        }
    }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/message-renderer-display-links/src/builders/urlLinkBuilder.ts